import React from 'react'

import { ZariContext } from '_zari/context'

import { CodigosTransaccionesConstant } from 'constants/index'

import { Portlet, Table } from '_zari/core'

import * as UsuariosService from 'services/usuario.service'

import { CambiarContraseniaModal } from '../modals'

const tableHeaderRows = [
  { label: 'USUARIO', filter: { type: 'text', name: 'username' } },
  { label: 'NOMBRES', filter: { type: 'text', name: 'nombres' } },
  { label: 'APELLIDOS', filter: { type: 'text', name: 'apellidos' } },
  { label: '', width: 60 }
]

const ListaUsuariosPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const [modalCambiarContrasenia, setModalCambiarContrasenia] = React.useState(false)
  const [idSeleccionado, setIdSeleccionado] = React.useState('')

  const tablaRef = React.useRef(null)

  const clickNuevoHandler = e => {
    e.preventDefault()
    history.push(`/${CodigosTransaccionesConstant.USUARIOS_NUEVO}`)
  }

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await UsuariosService.eliminarxId(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado.')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )
  const clickCambiarContrasenia = React.useCallback(({ _id }) => {
    setIdSeleccionado(_id)
    setModalCambiarContrasenia(true)
  }, [])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.USUARIOS_NUEVO}/${_id}`)
    },
    [history]
  )

  const clickVerFirmas = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.USUARIOS_FIRMAS}/${_id}`)
    },
    [history]
  )

  const clickVerSeries = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.USUARIOS_SEDES_SERIES}`)
    },
    [history]
  )

  const rowTemplate = React.useCallback(
    row => (
      <Table.Row hover key={row._id}>
        <Table.Cell>{row.username || '--'}</Table.Cell>
        <Table.Cell>{row.nombres || '--'}</Table.Cell>
        <Table.Cell>{row.apellidos || '--'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                Editar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item
                key='ver-firmas'
                handleClose={handleClose}
                onClick={e => clickVerFirmas({ _id: row._id })}
              >
                Ver Firmas
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item
                key='cambiarContrasenia'
                handleClose={handleClose}
                onClick={e => clickCambiarContrasenia({ _id: row._id })}
              >
                Cambiar Contraseña
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item
                key='eliminar'
                handleClose={handleClose}
                onClick={e => clickEliminar({ _id: row._id })}
              >
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEditar, clickEliminar, clickCambiarContrasenia, clickVerFirmas]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Usuarios'
          buttons={[
            { name: 'Nuevo', onClick: clickNuevoHandler },
            { name: 'Informe series', onClick: clickVerSeries }
          ]}
        />
        <Portlet.Body>
          <Table.ServerSide
            useNest={true}
            useFilters={true}
            ref={tablaRef}
            url='/usuarios'
            headRows={tableHeaderRows}
            rowTemplate={rowTemplate}
          />
        </Portlet.Body>
      </Portlet>
      {modalCambiarContrasenia && (
        <CambiarContraseniaModal
          show={modalCambiarContrasenia}
          handleClose={() => setModalCambiarContrasenia(prev => !prev)}
          id={idSeleccionado}
        />
      )}
    </>
  )
}

export default ListaUsuariosPage
